module.exports = __webpack_public_path__ + "img/def.defb8d1e.png";